import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ManagedProcurement from "@/pages/ManagedProcurement";
import WorkplaceOperations from "@/pages/WorkplaceOperations";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import Admin from "@/pages/Admin";
import FAQPage from "@/pages/FAQPage";
import Policy from "@/pages/Policy";
import OneDesk from "@/pages/OneDesk";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/managed-procurement" element={<ManagedProcurement />} />
          <Route path="/workplace-operations" element={<WorkplaceOperations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/onedesk" element={<OneDesk />} />
          <Route path="/privacy" element={<Policy slugOverride="privacy" />} />
          <Route path="/terms" element={<Policy slugOverride="terms" />} />
          <Route path="/shipping-delivery" element={<Policy slugOverride="shipping-delivery" />} />
          <Route path="/returns-replacement" element={<Policy slugOverride="returns-replacement" />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
